export { default as CategorySection } from './CategorySection';



// WEBPACK FOOTER //
// ./src/containers/ModulePage/CategorySection/index.ts